import { css } from "@emotion/react";

const button = css`
  margin-top: 24px;
`;

const input = prop => css`
  .MuiInputBase-input {
    @media (max-width: ${prop.theme.screenSizes.mdMax}) {
      height: 56px !important;
      font-size: 16px;
    }
  }
`;

const label = prop => css`
  @media (max-width: ${prop.theme.screenSizes.mdMax}) {
    font-size: 16px;
    top: 0;
  }
`;

const select = prop => css`
    @media (max-width: ${prop.theme.screenSizes.mdMax}) {
        height: 56px !important;
    }
}
`;

const addStyleSelect = { select, label };

export const addStyles = { button, input, addStyleSelect };
